import React, { Component } from 'react';
import { getLocationMenuPath } from '../../utils/urls/chartUrls';

class MapLink extends Component {

  constructor(props) {
    super(props);
    this.analytics = this.props.analytics;
  }

  handleClick = (event) => {
    const { doTrackEvent, children, trackingData, slug } = this.props;

    doTrackEvent('Location Clicked', {
      locationName: children,
      locationId: slug,
      subregionName: trackingData.subRegion,
      subregionId: trackingData.subRegionId,
      regionName: trackingData.region,
      regionId: trackingData.regionId,
    });

    window.location.assign(getLocationMenuPath(this.props.region, slug));
  }


  render() {
    const href = getLocationMenuPath(this.props.region, this.props.slug);
    return (
      <li
        onClick={this.handleClick}
        className={this.props.className}
      >
        <a onClick={this.handlClick} href={href}>
          {this.props.children}
        </a>
      </li>
    );
  }

}

export default MapLink;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/MapLink.js